import { useState } from 'react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

interface TerminateTransientStayDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingNumber: string
  onConfirm: (params: { termination_reason?: string }) => void
  isPending: boolean
}

export function TerminateTransientStayDialog({
  open,
  onOpenChange,
  bookingNumber,
  onConfirm,
  isPending,
}: TerminateTransientStayDialogProps) {
  const [reason, setReason] = useState('')

  function handleConfirm() {
    onConfirm({ termination_reason: reason.trim() || undefined })
  }

  function handleOpenChange(next: boolean) {
    if (!next) setReason('')
    onOpenChange(next)
  }

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Terminate Stay</AlertDialogTitle>
          <AlertDialogDescription>
            Terminate booking{' '}
            <span className="font-mono font-semibold">{bookingNumber}</span>?
            This will end the stay immediately and check the aircraft out.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="space-y-2 py-2">
          <Label htmlFor="terminate-reason">Reason (optional)</Label>
          <Textarea
            id="terminate-reason"
            placeholder="e.g. Lease violation, early departure request…"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={2}
          />
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Keep Active</AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? 'Terminating…' : 'Terminate Stay'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
